module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "BAT.1212afba.svg";